module.exports = __webpack_public_path__ + "imgs/leafwell3.e17e317e31fc45f13aea822fffe5139a.svg";